module.exports = "/_next/static/images/tier-cards-e115c63e108200fab0009ee546f37b6d.jpg";